
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import resultDeclarationapi from '../api/resultDeclaration';
import loginapi from '../api/login';

import Course from '../components/ResultBatchCard';
import { APISERVERURL } from '../APIServerURL';

function ResultDeclarationBatches({accessToken,setAccessToken,setRefreshFailed,resultEntrySession,setResultEntrySession,sessions}) 
{
  const navigate = useNavigate();
  const [courses,setCourses]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  const [busyAllGradeCardsReportBG,setBusyAllGradeCardsReportBG]=useState(false);
  const [busyAllGradeCardsReport,setBusyAllGradeCardsReport]=useState(false);
  const [busyAllResultCSVReport,setBusyAllResultCSVReport]=useState(false);
    const sessionChanged = async (e) => {
    const session = e.target.value;
    setResultEntrySession(session);

  };



  useEffect(()=>{
    const fetchAT=async ()=>{
      try{       
        setIsAppLoaded(false);
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await resultDeclarationapi.post('/getResultBatches',{session:resultEntrySession},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setCourses(response.data.allbatches); 
        
      
        setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPosition");
  
          if (mainElement && scrollPosition) {
              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100); // Delay for 100ms to ensure DOM is ready

        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await resultDeclarationapi.post('/getResultBatches',{session:resultEntrySession},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data.allbatches); 
                        setTimeout(() => {
                          const mainElement = document.querySelector("main"); // Target <main> directly
                          const scrollPosition = sessionStorage.getItem("scrollPosition");
                  
                          if (mainElement && scrollPosition) {
                              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
                              //console.log("Restored Scroll Position:", scrollPosition);
                          }
                      }, 100); // Delay for 100ms to ensure DOM is ready
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[resultEntrySession]);
  
  


  
    function downloadFile(fname)
      {
        fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
          response.blob().then((blob) => {
           
              // Creating new object of PDF file
              const fileURL =
                  window.URL.createObjectURL(blob);
                   
              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = fname;
              alink.click();
              //setIsloading(false);
          });
        });
      }
  async function downloadAllGradeCards(e,bg,session,batch,fromNO,toNo)//downloadstranscript
      {
        
        try{
          const response= await resultDeclarationapi.post('/downloadAllConsolidatedGradeCardsOfASessionBatch',{session,batch,bg,fromNO,toNo},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await resultDeclarationapi.post('/downloadAllConsolidatedGradeCardsOfASessionBatch',{session,batch,bg,fromNO,toNo},{headers:{'Authorization':`Bearer ${nat}`}});    
              alert(response.data);
              downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
      }
 async function downloadMeritList(e,bg,session,batch)
      {
        
        try{
          const response= await resultDeclarationapi.post('/downloadMeritListOfASessionBatch',{session,batch,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await resultDeclarationapi.post('/downloadMeritListOfASessionBatch',{session,batch,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
              alert(response.data);
              downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
      }
      
   async function downloadAllGradeCardsOfAllStudents(e,bg,session,batch,fromNO,toNo)
      {
        
        try{
          const response= await resultDeclarationapi.post('/downloadAllGradeCardsOfAllStudentsOfASessionBatch',{session,batch,bg,fromNO,toNo},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await resultDeclarationapi.post('/downloadAllGradeCardsOfAllStudentsOfASessionBatch',{session,batch,bg,fromNO,toNo},{headers:{'Authorization':`Bearer ${nat}`}});    
              alert(response.data);
              downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
      }

  async function downloadAllGradeCardsReports(e,bg,session){
    //alert("OK "+session);
    if(bg==='yes')
      {setBusyAllGradeCardsReportBG(true);
      }
      else{
        setBusyAllGradeCardsReport(true);
      }
    try{
          const response= await resultDeclarationapi.post('/generateAllGradeCardsReport',{session,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(JSON.stringify(response.data));
          //downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await resultDeclarationapi.post('/generateAllGradeCardsReport',{session,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(JSON.stringify(response.data));
          //downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
        finally
        {
         if(bg==='yes')
      {setBusyAllGradeCardsReportBG(false);
      }
      else{
        setBusyAllGradeCardsReport(false);
      }
        }
  }


async function downloadAllResultCSVReports(e,bg,session){
    //alert("OK "+session);
    
        setBusyAllResultCSVReport(true);
      
    try{
          const response= await resultDeclarationapi.post('/generateAllResultCSVReport',{session,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(JSON.stringify(response.data));
          //downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await resultDeclarationapi.post('/generateAllResultCSVReport',{session,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(JSON.stringify(response.data));
          //downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
        finally
        {
         setBusyAllResultCSVReport(false);
        }
  }


    return (
      <main>
        <div className="flex flex-col items-center">
          <div className="text-center mb-4">
            <h1 className="text-2xl font-bold text-gray-800 ">RESULT DECLARATION BATCHES</h1>
          </div>

          <div className="text-center mb-4">
            <p className="text-center">Select Exam session</p>
            <select
        value={resultEntrySession}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>


          



          <div className="flex flex-col items-center gap-6 mt-9">
  {/* 1. Global Report Section */}
  {isAppLoaded && courses.length > 0 && (
    <div className="flex flex-col justify-center items-center w-full max-w-md p-4 bg-gray-100 rounded-lg shadow-sm border border-gray-200 text-center">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">Global Actions for {resultEntrySession}</h3>
      <button
  onClick={(e) => downloadAllGradeCardsReports(e, "yes", resultEntrySession)}
  disabled={busyAllGradeCardsReportBG || busyAllGradeCardsReport}
  className="flex items-center justify-center px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-not-allowed transition-colors min-w-[280px]"
>
  {busyAllGradeCardsReportBG ? (
    <>
      {/* Tailwind Spinner */}
      <svg 
        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        ></circle>
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      Generating Report...
    </>
  ) : (
    "Download All GradeCards - with BG"
  )}
</button>

<button
  onClick={(e) => downloadAllGradeCardsReports(e, "no", resultEntrySession)}
  disabled={busyAllGradeCardsReportBG||busyAllGradeCardsReport}
  className="flex items-center justify-center px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-not-allowed transition-colors min-w-[280px] mt-4"
>
  {busyAllGradeCardsReport ? (
    <>
      {/* Tailwind Spinner */}
      <svg 
        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        ></circle>
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      Generating Report...
    </>
  ) : (
    "Download All GradeCards - No BG"
  )}
</button>
{(busyAllGradeCardsReportBG || busyAllGradeCardsReport)&& <p>Please wait. Dont leave the page. It might take a few minutes.</p> }



   <button
  onClick={(e) => downloadAllResultCSVReports(e, "no", resultEntrySession)}
  disabled={busyAllResultCSVReport||busyAllResultCSVReport}
  className="flex items-center justify-center px-6 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700 disabled:bg-yellow-400 disabled:cursor-not-allowed transition-colors min-w-[280px] mt-4"
>
  {busyAllResultCSVReport ? (
    <>
      {/* Tailwind Spinner */}
      <svg 
        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        ></circle>
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      Generating all result CSV Report
    </>
  ) : (
    "Download All result CSV"
  )}
</button>
{(busyAllResultCSVReport || busyAllResultCSVReport)&& <p>Please wait. Dont leave the page. It might take a few minutes.</p> }



    </div>
  )}

  {/* 2. Individual Courses Grid */}
  <div className="flex flex-wrap justify-center gap-4 mt-9">
          {isAppLoaded ? (
            courses.length > 0 ? (
              //here i want a div with a button.
              courses.map((course) => (
                <Course key={course.batch} course={course} session={resultEntrySession} downloadAllGradeCards={downloadAllGradeCards}  downloadMeritList={downloadMeritList} downloadAllGradeCardsOfAllStudents={downloadAllGradeCardsOfAllStudents}/>
              ))
            ) : (
              <p>No batches available.</p>
            )
          ) : (
            <p>Please wait...</p>
          )}
          </div>
</div>


        </div>

     
      </main>
    )
  }
  
  export default ResultDeclarationBatches